var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.8535,
    cy: 20.8535,
    r: 20.8535,
    fill: "#FFF7ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4776 9.10118C32.3554 9.0105 32.1963 8.99226 32.0578 9.05297L8.43422 18.9042L5.63574 20.1042L14.0917 23.6417H14.1011V23.6465L16.3632 31.806C16.4087 31.9703 16.5351 32.0973 16.6952 32.14C16.8554 32.1826 17.0254 32.1344 17.1421 32.0133L21.8528 27.0347L28.21 29.618C28.472 29.7286 28.7686 29.7086 29.0145 29.5637C29.2604 29.4188 29.4281 29.1651 29.4693 28.8758L32.6782 9.60238C32.7195 9.4084 32.6394 9.20835 32.4776 9.10118ZM18.7791 25.7431L18.7885 25.7093L18.8025 25.7141L18.7791 25.7431Z",
    fill: "#FFA63E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8533 27.0354L17.1426 32.014C17.1975 31.9522 17.2375 31.8779 17.2592 31.7971L18.7797 25.7438L18.803 25.7148L20.8272 26.592L21.7321 26.9872L21.8533 27.0354Z",
    fill: "#F79420"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5124 9.12695L18.8028 25.7139L18.7888 25.7091L18.7794 25.7429L17.2589 31.7962C17.2372 31.877 17.1973 31.9513 17.1423 32.0131C17.0257 32.1341 16.8556 32.1824 16.6955 32.1398C16.5353 32.0972 16.409 31.9701 16.3634 31.8058L14.1013 23.6463V23.6415H14.0967V23.6367L32.5124 9.12695Z",
    fill: "#E67D01"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMoney);
export default __webpack_public_path__ + "static/media/sendMoney.057d5881695ccbfd2ba2a2bcc252fc46.svg";
export { ForwardRef as ReactComponent };